import React, { useState } from "react";
import { NavSidebar } from "./NavSidebar";
import { AppHeader } from "./AppHeader";
import Footer from "./Footer";
import Messages from "../../lib/components/Messages";
import "./styles/AppShell.css";

export function AppShell({
  user,
  notificationCount,
  onNotificationsClick,
  onProfileClick,
  children,
}) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={"cp-shell" + (collapsed ? " cp-shell--collapsed" : "")}>
      <NavSidebar user={user} collapsed={collapsed} onToggle={setCollapsed} />

      <div className="cp-shell__main">
        <AppHeader />

        <main className="cp-shell__content">
          <div className="cp-shell__messages">
            <Messages />
          </div>
          <div className="cp-shell__container">{children}</div>
        </main>

        <Footer />
      </div>
    </div>
  );
}
